import { EmployeeWorkHours } from "../../entities/EmployeeWorkHours";
import { EmployeeLocationHistoryService } from "../../services/EmployeeLocationHistoryService";
import { EmployeeWorkHoursService } from "../../services/EmployeeWorkHoursService";

export class EmployeeWorkHoursModel {
    $q:ng.IQService;
    entityId:number;
    allWorkHours:EmployeeWorkHours[] = [];
    static $inject = ['$q','EmployeeWorkHoursService'];
    constructor($q: ng.IQService,
        public employeeWorkHoursService: EmployeeWorkHoursService) {
        this.$q = $q;
    }
    init(entityId:number):ng.IPromise<boolean>{
        if (entityId == null) {
            return this.$q.when<boolean>(true);
        }
        this.entityId = entityId;
        return this.$q.all([
            this.employeeWorkHoursService.getWorkHoursByEmployee(entityId)
        ]).then((data) => {
            this.allWorkHours = data[0];
            return this.$q.when<boolean>(true);
        });
    }
}
